import { AppData, AppDataResponse, IWindowCustom, Participant, TransferData } from "types";
import { AppStore, AuthStore, DataStore as DataStoreInterface } from "interfaces";

import { API } from 'services';
import { Currency } from 'enums';
import { ENDPOINTS } from 'endpoints';
import { getMobileOS, isNumberValue } from "utils";
import { makeAutoObservable } from 'mobx';

declare const window: IWindowCustom;

export class DataStore implements DataStoreInterface {
  constructor(authStore: AuthStore, appStore: AppStore) {
    makeAutoObservable(this);
    this.authStore = authStore;
    this.appStore = appStore;
  }

  authStore: AuthStore;
  appStore: AppStore;

  currency: Currency = Currency.UAH;
  appData: AppData | null = null;
  transferData: TransferData = { needExtraData: false, hasExchanged: false };
  selectedParticipant: Participant | null = null;

  getAppData = async (): Promise<AppData> => {
    const response = await API.get<AppDataResponse, unknown>({
      resource: ENDPOINTS.GET_APP_DATA,
      options: {
        searchParams: { splitId: this.appStore.id },
        headers: { Authorization: `Bearer ${this.authStore.token}`, 'Accept-Language': this.appStore.lang },
      },
    });
    const result: AppData = {
      amount: response.data.amountTotal,
      status: response.data.status,
      recipient: response.data.recipient,
      participants: response.data.participantList || [],
      isWithoutAmount: Boolean(response.data.isSplitWithoutAmount),
      deepLinkApp: response.data.deepLink,
      expireDateApp: response.data.expireDateApp
    };

    //TODO - refactor to to mock api

    // const response = require('../../mocks/AppDataWithoutParticipantsResponse.json');
    // const result: AppData = {
    //   amount: response.payload.amountTotal,
    //   status: response.payload.status,
    //   recipient: response.payload.recipient,
    //   participants: response.payload.participantList || [],
    //   isWithoutAmount: Boolean(response.payload.isSplitWithoutAmount),
    //   deepLinkApp: response.payload.deepLinkApp,
    //   expireDateApp: response.payload.expireDateApp
    // };

    return result;
  };

  setCurrency = (currency: Currency) => {
    this.currency = currency;
  };

  setAppData = (data: AppData) => {
    this.appData = data;
  };

  setTransferData = (transferData: TransferData) => {
    this.transferData = { ...this.transferData, ...transferData };
  };

  setSelectedParticipant = (participant: Participant | null) => {
    this.selectedParticipant = participant;
  };

  get isActive() {
    return this.appData?.status === 'active';
  }

  get isClosed() {
    return this.appData?.status === 'close' || this.appData?.status === 'deactivated';
  }

  get hasAmount() {
    return isNumberValue(this.appData?.amount);
  }

  get hasParticipants(): boolean {
    return !!this.appData && this.appData.participants.length > 0;
  }

  get isiOS(): boolean {
    return getMobileOS() === "ios" && window.ApplePaySession && window.ApplePaySession.canMakePayments();
  }
}

export default DataStore;
